// extracted by mini-css-extract-plugin
export var divider = "_k0-0";
export var systemMessage = "_k0-1";